import React from "react";
import LayoutBase from "./LayoutBase";
import { HomeOutlined } from "@ant-design/icons";

import RegisterIndividualScreen from "./RegisterIndividualScreen";

type Props = { responeConfig: any };

const RegisterIndividual: React.FC<Props> = ({ responeConfig }) => {
  const sideBar = (
    <div className="content-sidbar">
      <div className="content-sidbar-register" style={{ fontSize: "1.2rem" }}>
        <HomeOutlined rev={undefined} />
        <div>
          <div>ลงทะเบียนบริษัท</div>
          <div style={{ fontWeight: "lighter" }}>ประเภทบุคคลธรรมดา</div>
        </div>
      </div>
    </div>
  );

  return (
    <LayoutBase responeConfig={responeConfig} sideMenu={sideBar}>
      <RegisterIndividualScreen />
    </LayoutBase>
  );
};

export default RegisterIndividual;
